import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { correctionRecordList, correctionRecordExport, recordExportVerify } from '../request';
import correctionDetail from './correctionDetail.vue';
import batchDownRecord from './batchDownRecord.vue';
import { downloadFileFun } from '@/utils/public';
import moment from 'moment';
import { REDUCE, REPLACE, ADD } from '../../customerManage/correctionApplication/util';
export default {
  data() {
    return {
      form: {
        correctTime: null,
        correctEffectiveTime: null,
        applyNumber: ''
      },
      correctionRecordList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      detailVisible: false,
      batchDownVisible: false,
      correctionItem: {}
    };
  },
  components: {
    correctionDetail,
    batchDownRecord
  },
  created() {
    this.getRecordList();
  },
  methods: {
    onShowSizeChange(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getRecordList();
    },
    searchList() {
      this.pagination.current = 1;
      this.getRecordList();
    },
    getRecordList() {
      var _this$form$correctTim, _this$form$correctTim2, _this$form$correctEff, _this$form$correctEff2, _this$form$applyNumbe;
      let correctStartAt = (_this$form$correctTim = this.form.correctTime) !== null && _this$form$correctTim !== void 0 && _this$form$correctTim[0] ? moment(this.form.correctTime[0]).format('YYYY-MM-DD') : '';
      let correctEndAt = (_this$form$correctTim2 = this.form.correctTime) !== null && _this$form$correctTim2 !== void 0 && _this$form$correctTim2[1] ? moment(this.form.correctTime[1]).format('YYYY-MM-DD') : '';
      let correctEffectiveStartAt = (_this$form$correctEff = this.form.correctEffectiveTime) !== null && _this$form$correctEff !== void 0 && _this$form$correctEff[0] ? moment(this.form.correctEffectiveTime[0]).format('YYYY-MM-DD') : '';
      let correctEffectiveEndAt = (_this$form$correctEff2 = this.form.correctEffectiveTime) !== null && _this$form$correctEff2 !== void 0 && _this$form$correctEff2[1] ? moment(this.form.correctEffectiveTime[1]).format('YYYY-MM-DD') : '';
      let params = {
        policyId: this.$route.params.id,
        applyNumber: ((_this$form$applyNumbe = this.form.applyNumber) === null || _this$form$applyNumbe === void 0 ? void 0 : _this$form$applyNumbe.trim()) || '',
        correctStartAt: correctStartAt,
        correctEndAt: correctEndAt,
        correctEffectiveStartAt: correctEffectiveStartAt,
        correctEffectiveEndAt: correctEffectiveEndAt,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      correctionRecordList(params).then(res => {
        this.pagination.total = Number(res.totalNum);
        res.items.forEach(item => {
          let detailObj = JSON.parse(item.detail);
          let detailText = detailObj.detail;
          item.detailText = detailText;
          let replaceItems = [];
          let incrementItems = [];
          let reduceItems = [];
          detailObj.safeguard.forEach((item, index) => {
            if (item.type === REPLACE) {
              replaceItems.push(item);
            } else if (item.type === ADD) {
              incrementItems.push(item);
            } else if (item.type === REDUCE) {
              reduceItems.push(item);
            }
          });
          detailObj.replaceItems = replaceItems;
          detailObj.incrementItems = incrementItems;
          detailObj.reduceItems = reduceItems;
          item.detailObj = detailObj;
        });
        this.correctionRecordList = res.items;
      });
    },
    resetFun() {
      this.pagination.current = 0;
      this.pagination.pageSize = 10;
      this.$refs.dataform.resetFields();
      this.getRecordList();
    },
    addFun() {
      this.$emit('addFun');
    },
    toDetail(item) {
      this.correctionItem = item;
      this.detailVisible = true;
    },
    closeDetail() {
      this.detailVisible = false;
      this.correctionItem = {};
    },
    downSingleRecord(record) {
      let params = {
        correctRecordId: record.id
      };
      recordExportVerify(params).then(res => {
        if (res === true) {
          correctionRecordExport(params).then(res1 => {
            if (res1) {
              downloadFileFun(res1, 'application/vnd.ms-excel', record.applyNumber + '批改人员.xlsx');
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onPageChange(page, pagesize) {
      this.pagination.pageSize = pagesize;
      this.pagination.current = page;
      this.getRecordList();
    }
  }
};